module.exports = __webpack_public_path__ + "img/Empfangen_anywhere_2.61d74867.png";